import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocNationalityEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id="nationality">Nationality</h3>
                    <div className="description">The extraction of an entity type nationality is modeled around detecting nationality of the 
                    countries when mentioned in the document. Nationalities entities may have an associated FinchId. An example of a nationality can be seen below:
                    </div>
                    <div className="example-content">
                        <div className="line">American</div>
                        <div className="line">Italian</div>
                        <div className="line">Russian</div>
                    </div>
                    <br/>
                    
                    <h5 className="heading-2">Example</h5>
                    <div className="example-content">
                        Edward Snowden is under the care of the Russian authorities and can't leave Moscow's 
                        international airport without their consent, Ecuadorean President Rafael Correa has said in an 
                        interview telegraphing the slim and diminishing possibility that the National Security Agency 
                        leaker will end up in Ecuador. Russian President Vladimir Putin has distanced himself from the 
                        case since Snowden arrived in Russia last week. Cuban leader Fidel Castro praised Correa's 
                        rejection of US trade pressure, expressing his sympathies for the Ecuadorean leader in a 
                        Sunday editorial in the state press. - AP.
                    </div>
                    <HttpRunner example="nationality1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_NATIONALITY) : null}/>
                </div>
            </div>
        );
    }
}

export default DocNationalityEntity;